import { useEffect, useRef } from "react"

import { trackDocumentSearchInDialog } from "../../app/services/tracking"
import type { SearchDialogContext } from "../DocumentSearchContent/useDocumentSearch"

export function useDocumentSearchTracking({
  filters,
  isFetching,
  totalDocuments,
}: TrackFiltersParams) {
  const filtersRef = useRef(filters)
  const startTimeRef = useRef<number | null>(null)

  useEffect(() => {
    if (filters.hasFiltersApplied) startTimeRef.current = Date.now()
    filtersRef.current = filters
  }, [filters])

  useEffect(() => {
    if (isFetching || !startTimeRef.current) {
      return
    }

    const timeToGetResultsInMs = Date.now() - startTimeRef.current

    const filtersUsed = [
      filtersRef.current.customType.length ? "customTypes" : "",
      filtersRef.current.tag.length ? "tags" : "",
      filtersRef.current.status.length ? "status" : "",
      filtersRef.current.authors.length ? "authors" : "",
    ].filter(Boolean)

    trackDocumentSearchInDialog({
      searchQuery: filtersRef.current.searchTerm,
      numberOfWords: filtersRef.current.searchTerm?.split(" ").length,
      numberOfResults: totalDocuments,
      timeToGetResultsInMs: timeToGetResultsInMs,
      filtersUsed,
    })

    startTimeRef.current = null
  }, [isFetching, totalDocuments])
}

interface TrackFiltersParams {
  filters: SearchDialogContext["filters"]
  isFetching: boolean
  totalDocuments: number
}
